export default function($) {
  var PB_Compute_Totals_After_Discount = function( bundle ) {

    /**
     * 'bundle_total_price_html' filter callback.
     */
    this.filter_bundle_total_price_html = function( price_html, bundle ) {
      var discount_data = $('#js-client_discount_data').data('discount_data')
      var current_total_price = $.extend( true, {}, bundle.price_data ).totals.price

      var current_total_items_quantity = 0
      $.each( bundle.bundled_items, function ( index, bundled_item ) {
        if (bundled_item.$self.find('.bundled_product_checkbox').attr('checked') == "checked") {
          current_total_items_quantity += bundled_item.get_quantity()  
        }
      } )
      // to put back on when will be possible to apply to variantions
      // if (current_total_items_quantity <= 1) {
      //   return price_html
      // }

      var discount_on_total = 0

      $.each( discount_data, function ( index, discount_data_line ) {
        var price_min = discount_data_line.quantity_min
        var price_max = discount_data_line.quantity_max

        if (current_total_price >= price_min  && current_total_price <= price_max) {
          discount_on_total = discount_data_line.discount
          return false // break;
        }
      } )

      if (discount_on_total === 0) {
        return price_html
      }

      var new_total = current_total_price - discount_on_total

      var currency_symbol_html = $('<span></span>').addClass('woocommerce-Price-currencySymbol').text(" €").html()

      var new_price_html = $('<span style="font-weight: bold;"></span>')
        .addClass('woocommerce-After-Discount-Price-amount')
        .text(parseFloat(new_total).toFixed(2))
        .append(currency_symbol_html)

      var old_price_html = $('<span style="text-decoration: line-through;"></span>')
        .addClass('woocommerce-Before-Discount-Price-amount')
        .text(parseFloat(current_total_price).toFixed(2))
        .append(currency_symbol_html)

      var price_html_to_display = $('<span style=""></span>')
        .addClass('woocommerce-Price-amount')
        .append(new_price_html)
        .append(" ")
        .append(old_price_html)
        .html()


      return price_html_to_display
    };

    // Init.
    this.initialize = function() {
      /**
       * Filter price total html using 'bundle_total_price_html' JS filter.
       */
      bundle.filters.add_filter( 'bundle_total_price_html', this.filter_bundle_total_price_html, 10, this );
    };

  }
  
  // Hook into Bundles.
  $( '.bundle_form .bundle_data' ).each( function() {
    $( this ).on( 'woocommerce-product-bundle-initializing', function( event, bundle ) {
      var compute_totals_after_discount = new PB_Compute_Totals_After_Discount( bundle );
      compute_totals_after_discount.initialize();
    } );
  } );
}
